import { AxiosError } from 'axios';
import { useState } from 'react';

import { VehicleStatusDataInterface } from '../../../models/dashboard/dashboard/vehicle-status';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { vehicleStatusActions } from '../../../redux/slices/vehicleStatusSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useVehicleStatus = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onGetVehicleStatusError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onGetVehicleStatusSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<VehicleStatusDataInterface[]>) => {
        dispatch(vehicleStatusActions.setVehicleStatus(data));
    };

    const getVehicleStatus = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/vehicle-status`,
            method: 'get',
        };

        return request(url, onGetVehicleStatusSuccess, setLoading, onGetVehicleStatusError);
    };

    return { getVehicleStatus, loading };
};

export default useVehicleStatus;
